import { Spinner } from "@vwpfs/mary-air-lib/components/air/06-molecules/Spinner";
import * as React from "react";

/**
 * @description
 *  This component is used to show a loading spinner on the page.
 *  Make sure to load the root.css from Mary, else it won't work!
 */
export const PageLoader: React.FunctionComponent = () => (
    <>
        <div
            style={{
                height: "100vh",
                width: "100vw",
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 9999,
                background: "var(--scl-color-contrast--primary)",
            }}
        >
            <div
                style={{
                    position: "fixed",
                    left: "50%",
                    top: "50%",
                    transform: "translateX(-50%) translateY(-50%)",
                }}
            >
                <Spinner active />
            </div>
        </div>
    </>
);
